import useUser from "~/store/UserInfo"
import usePub from "~/store/Public"
import _ from "lodash";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const { ssrContext } = useNuxtApp();
    // if (to.params.id === '1') {
    //
    // }
    
    if (_.indexOf(["login", "register", "verify", "signup", "forgotPwd", "changepwd-code"], to.name) > -1) {
        setPageLayout("noheader");
        return;
    };
    setPageLayout("default");
    if (ssrContext) return navigateTo({
        name: "login"
    });

    // let result: { status: boolean, result: any } = {
    //     status: false,
    //     result: {
    //         msg: "",
    //         message: ""
    //     }
    // };
    // try {
    // usePub().loading = true
    const result = await useUser().checkUser();
    // usePub().loading = false
    
    if (!result) {
        return navigateTo({
            name: "login"
        });
    }
    // } catch (e) {
    //     console.log("B")
    // }

    // console.log(process , process.server,process && process.server);
    // if (process && process.client) {
    //     const MemStore = userMemberStore();
    //     const PubStore = usePubStore();
    //     const Login = await MemStore.checkLogin();
    //     if (!MemStore.isLogin) {
    //         PubStore.setAlertList({
    //             color: 'danger',
    //             name: '未登入會員',
    //             message: '請先註冊會員及登入',
    //             textcolor: "white"
    //         })
    //         return navigateTo("/");
    //     }
    //     console.log("Auth");
    // }
    // return abortNavigation()
    // return navigateTo()
})